import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pay-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './pay-button.component.html',
  styleUrl: './pay-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PayButtonComponent {
  readonly buttonDisabled = input<boolean>(false);

  @Output() readonly onPayClicked = new EventEmitter<void>();

  onSubmit(): void {
    this.onPayClicked.emit();
  }
}
